__webpack_require__.p = "/Dishcovery/";